import React, { useEffect, useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { Checkbox, FormControl, InputLabel, makeStyles, MenuItem, Select, TextField, Tooltip } from '@material-ui/core';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { Visibility, Add, LocalOfferSharp, Edit, Cancel, Save } from '@material-ui/icons';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { WithApp } from 'contexts/appContext';
import Button from 'components/CustomButtons/Button';
import CardIcon from 'components/Card/CardIcon';
import { Fragment } from 'react';
import ButtonDelete from 'hooks/ButtonDelete';
import { wsFindBy } from 'services/WService';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import DuplicatePromotionModal from './DuplicatePromotionModal';
import { useModal } from 'hooks/useModal';
import moment from 'moment';
import { wsUpdate } from 'services/WService';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    fontSize: '18px',
  },
  totals: {
    fontWeight: 'bold',
    width: '170px',
  },
});

const promotionTableColumns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 140 },
  { Header: 'ID', accessor: 'idPromotion', width: 100 },
  { Header: 'Canal', accessor: 'canals', width: 80 },
  { Header: 'Zonas', accessor: 'zones', width: 120, align: 'center' },
  { Header: 'Nombre proveedor', accessor: 'CardName' },
  { Header: 'Descripción', accessor: 'description' },
  { Header: 'Límite', accessor: 'limit', width: 100 },
  { Header: 'Ult.Asignación', accessor: 'ultima_asignacion', width: 150 },
  { Header: 'Avance Mes', accessor: 'avance_del_mes', width: 150 },
  { Header: 'Asignado', accessor: 'asig', width: 100 },
  { Header: 'Disponible', accessor: 'disp', width: 100 },
  { Header: 'Tipo compra', accessor: 'evaluation_type', width: 140 },
  { Header: 'Tipo bono', accessor: 'bonification_type', width: 130 },
  { Header: 'Estado', accessor: 'state', width: 100 },
  { Header: 'Desde', accessor: 'start_date', width: 130 },
  { Header: 'Hasta', accessor: 'end_date', width: 130 },
  { Header: 'Cond. Venta', accessor: 'sale_condition', width: 140, align: 'center' },
  { Header: 'Origen', accessor: 'origin', width: 100 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

const states = [
  { value: 'P', name: 'Aprobado' },
  { value: 'V', name: 'Vigente' },
  { value: 'L', name: 'Liquidado' },
  { value: 'I', name: 'Inactivo' },
  { value: 'G', name: 'Generado' },
  { value: 'N', name: 'Nuevo' },
  { value: 'C', name: 'Cancelado' },
];

function mapPromotionData(
  promotion,
  setPromotions,
  i,
  listPromotions,
  selectedPromotions,
  setSelectedPromotions,
  edit,
) {
  let origin = '';
  switch (promotion.origin) {
    case 'E':
      origin = 'Externo';
      break;
    case 'I':
      origin = 'Interno';
      break;
    default:
      origin = promotion.origin;
  }
  let state = '';
  switch (promotion.state) {
    case 'P':
      state = 'Aprobado';
      break;
    case 'V':
      state = 'Vigente';
      break;
    case 'L':
      state = 'Liquidado';
      break;
    case 'I':
      state = 'Inactivo';
      break;
    case 'G':
      state = 'Generado';
      break;
    case 'N':
      state = 'Nuevo';
      break;
    case 'C':
      state = 'Cancelado';
      break;
    default:
      state = promotion.state;
  }

  let evaluation_type = '';
  switch (promotion.evaluation_type) {
    case 'P':
      evaluation_type = 'Producto';
      break;
    case 'S':
      evaluation_type = 'Proveedor';
      break;
    case 'C':
      evaluation_type = 'Categoría';
      break;
    case 'F':
      evaluation_type = 'Familia';
      break;
    default:
      evaluation_type = promotion.evaluation_type;
  }

  let bonification_type = '';
  switch (promotion.bonification_type) {
    case 'P':
      bonification_type = 'Producto';
      break;
    case 'D':
      bonification_type = 'Descuento %';
      break;
    case 'S':
      bonification_type = 'Descuento S./';
      break;
    default:
      bonification_type = promotion.bonification_type;
  }

  let limit = promotion.updated_limit_promotion || promotion.limit_promotion;
  let limitForCalculed = promotion.limit_promotion;

  let asig = promotion.advance_promotion;

  let sale_condition = '';
  switch (promotion.sale_condition) {
    case 'A':
      sale_condition = 'Ambos';
      break;
    case 'C':
      sale_condition = 'Contado';
      break;
    case 'R':
      sale_condition = 'Crédito';
      break;
    default:
      sale_condition = promotion.sale_condition;
  }

  function handleChange(e) {
    let name = e.target.name;
    let value = e.target.value;
    // Alerta de fecha no sea superior al mes actual
    if (name === 'start_date' || name === 'end_date') {
      if (moment().month() !== moment(value).month()) {
        if (!window.confirm('La fecha ingresada es de un mes diferente al actual, continuar?')) {
          return;
        }
      }

      // Validación de fechas
      if (name === 'start_date') {
        if (moment(value).isAfter(moment(promotion.updated_end_date || promotion.end_date))) {
          window.alert('La fecha ingresada es mayor a la fecha fin');
          return;
        }
      }
      if (name === 'end_date') {
        if (moment(value).isBefore(moment(promotion.updated_start_date || promotion.start_date))) {
          window.alert('La fecha ingresada es menor a la fecha de inicio');
        }
      }
    }

    setPromotions((promotions) => {
      let newPromotions = [...promotions];
      let index = newPromotions.findIndex((p) => promotion.id === p.id);
      if (index !== -1) {
        newPromotions[index][`updated_${name}`] = value;
        newPromotions[index].edited = true;
      }
      return newPromotions;
    });
  }

  return {
    num: (
      <div className="actions-right">
        {i + 1}
        <AllowedGuard permission={ConstantPermissions.PROM_PROMOTIONS_SHOW}>
          <Button justIcon round simple color="info" className="like">
            <Link to={`${promotion.id}`}>
              <Visibility />
            </Link>
          </Button>
        </AllowedGuard>
        <AllowedGuard permission={ConstantPermissions.PROM_PROMOTIONS_DELETED}>
          <ButtonDelete entity="prom/promotion" id={promotion.id} reload={listPromotions} />
        </AllowedGuard>
        <AllowedGuard permission={ConstantPermissions.PROM_PROMOTIONS_STORE}>
          <Checkbox
            margin="normal"
            checked={selectedPromotions.includes(promotion.id)}
            onChange={() => {
              // Quitar
              if (selectedPromotions.includes(promotion.id)) {
                setSelectedPromotions((selected) => {
                  let newSelected = [...selected];
                  let index = newSelected.findIndex((id) => id === promotion.id);
                  if (index !== -1) {
                    newSelected.splice(index, 1);
                  }
                  return newSelected;
                });
                // Agregar
              } else {
                setSelectedPromotions((selected) => {
                  let newSelected = [...selected];
                  newSelected.push(promotion.id);
                  return newSelected;
                });
              }
            }}
          />
        </AllowedGuard>
      </div>
    ),
    idPromotion: String(promotion.id),
    canals: promotion.canals,
    zones: promotion.zones.map((item) => item.code).toString(),
    CardName: promotion.CardName,
    description: promotion.description,

    limit: edit ? (
      <TextField
        name="limit_promotion"
        value={limit}
        disabled={promotion.state !== 'P'}
        onChange={handleChange}
        type="number"
        fullWidth
      />
    ) : (
      limit
    ),
    ultima_asignacion: promotion.ultima_asignacion || '-',
    avance_del_mes: promotion.avance_del_mes || '-',
    asig,
    disp: limitForCalculed - asig,

    evaluation_type,
    bonification_type,
    start_date: edit ? (
      <TextField
        name="start_date"
        value={promotion.updated_start_date || promotion.start_date}
        disabled={promotion.state !== 'P'}
        onChange={handleChange}
        type="date"
        fullWidth
        inputProps={{
          max: promotion.updated_end_date || promotion.end_date,
        }}
      />
    ) : (
      promotion.start_date
    ),
    end_date: edit ? (
      <TextField
        name="end_date"
        value={promotion.updated_end_date || promotion.end_date}
        disabled={promotion.state !== 'P'}
        onChange={handleChange}
        type="date"
        fullWidth
        inputProps={{
          min: promotion.updated_start_date || promotion.start_date,
        }}
      />
    ) : (
      promotion.end_date
    ),
    sale_condition,
    origin,
    state,
    actions: '',
  };
}

export default WithApp(function PromotionList(props) {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [promotions, setPromotions] = useState([]);
  const [state, setState] = useState(states[0]);
  const location = useLocation();
  const navigate = useNavigate();
  const [filters, setFilters] = useState();
  const [selectedPromotions, setSelectedPromotions] = useState([]);
  const [model, setOpen] = useModal();
  const [edit, setEdit] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);

  async function updatePromotions() {
    let promotionsToUpdate = promotions.filter(prom => prom.edited === true);
    if (promotionsToUpdate.length === 0) {
      window.alert('No hay promociones a actualizar');
      setEdit(false);
      return;
    }

    let data = promotionsToUpdate.map(prom => {
      let data = { id: prom.id };
      if ('updated_limit_promotion' in prom) {
        data.limit_promotion = prom.updated_limit_promotion;
      }
      if ('updated_start_date' in prom) {
        data.start_date = prom.updated_start_date;
      }
      if ('updated_end_date' in prom) {
        data.end_date = prom.updated_end_date;
      }
      return data;
    });

    setLoading(true);
    let res = await wsUpdate('prom/promotion/massive-update', { promotions: data });
    if (!res.success) {
      setLoading(false);
      window.alert(res.message);
      return;
    }

    setLoading(false);
    setEdit(false);
    setPromotions(promotions => {
      let newPromotions = [...promotions];
      newPromotions.map(prom => {
        if (prom.edited === true) {
          if ('updated_limit_promotion' in prom) {
            prom.limit_promotion = prom.updated_limit_promotion;
            delete prom.updated_limit_promotion;
          }
          if ('updated_start_date' in prom) {
            prom.start_date = prom.updated_start_date;
            delete prom.updated_start_date;
          }
          if ('updated_end_date' in prom) {
            prom.end_date = prom.updated_end_date;
            delete prom.updated_end_date;
          }
          delete prom.edited;
        }
        return prom;
      });
      return newPromotions;
    });
    window.alert(res.message);
  }

  function cancelUpdate() {
    setLoading(false);
    setEdit(false);
    setPromotions(proms => {
      let newPromotions = [...proms];
      newPromotions.map(prom => {
        if (prom.edited === true) {
          if ('updated_limit_promotion' in prom) {
            delete prom.updated_limit_promotion;
          }
          if ('updated_start_date' in prom) {
            delete prom.updated_start_date;
          }
          if ('updated_end_date' in prom) {
            delete prom.updated_end_date;
          }
          delete prom.edited;
        }
        return prom;
      });
      return newPromotions;
    });
  }

  async function listPromotions() {
    setDataLoading(true);
    setSelectedPromotions([]);
    let response = await wsFindBy('prom/promotion', { state: state.value, ...filters });
    setDataLoading(false);
    if (response.success) {
      setPromotions(response.data.map(prom => {
        prom.edited = false;
        return prom;
      }));
    };
  }

  function onFilterChange(filters) {
    if (filters.base_business_partner_id !== undefined) {
      navigate(`${location.pathname}?proveedor=${filters.base_business_partner_id}`, {
        replace: true,
      });
    } else {
      navigate(`${location.pathname}`, { replace: true });
    }
    setFilters(filters);
  }

  useEffect(() => {
    if (filters === undefined && new URLSearchParams(location.search).get('proveedor') !== null) {
      return;
    }
    listPromotions();
  }, [filters, state]);

  useEffect(() => {
    let searchParams = new URLSearchParams(location.search);
    if (searchParams.get('proveedor') !== null) {
      setFilters({ base_business_partner_id: searchParams.get('proveedor') });
    }
  }, []);

  return (
    <Fragment>
      <DuplicatePromotionModal model={model} setOpen={setOpen} />
      <Card>
        <CardHeader icon>
          <AllowedGuard
            permission={ConstantPermissions.PROM_PROMOTIONS_STORE}
            component={
              <CardIcon color="primary">
                <LocalOfferSharp style={{ color: 'white' }} />
              </CardIcon>
            }
          >
            <Link to="0">
              <CardIcon pointer="true" color={props.themeContext.buttonColorSuccess}>
                <Add style={{ color: 'white' }} />
              </CardIcon>
            </Link>
          </AllowedGuard>
          <div style={{ display: 'flex', justifyContent: 'space-between', color: 'black' }}>
            <span className={classes.cardIconTitle}>Promociones {dataLoading && <LoadingSpinner />}</span>
            <div className={classes.totals}>
              <FormControl fullWidth margin="normal" size="small">
                <InputLabel>Estado</InputLabel>
                <Select
                  value={state.value || ''}
                  inputProps={{
                    name: 'value',
                  }}
                >
                  {states.map((item, i) => {
                    return (
                      <MenuItem value={item.value} key={i} onClick={() => setState(item)}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
          </div>
        </CardHeader>
        <CardBody>
          <FilterCustom
            provider
            getFilter={onFilterChange}
            component={
              <GridContainer>
                <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
                  <Button
                    size="sm"
                    color="success"
                    disabled={loading || selectedPromotions.length === 0}
                    onClick={() =>
                      setOpen({
                        open: true,
                        promotions: promotions.filter((prom) =>
                          selectedPromotions.includes(prom.id),
                        ),
                      })
                    }
                  >
                    Duplicar promociones
                  </Button>
                </GridItem>
                {!edit && (
                  <AllowedGuard permission={ConstantPermissions.PROM_PROMOTIONS_UPDATE}>
                    <GridItem xs={12} sm={6} md={4} lg={3} xl={2}>
                      <Button
                        size="sm"
                        color="warning"
                        round
                        justIcon
                        disabled={loading}
                        onClick={() => setEdit((edit) => !edit)}
                      >
                        <Edit />
                      </Button>
                    </GridItem>
                  </AllowedGuard>
                )}
                {edit && (
                  <>
                    <Button
                      size="sm"
                      color="success"
                      round
                      justIcon
                      disabled={loading}
                      onClick={updatePromotions}
                    >
                      <Save />
                    </Button>
                    <Button
                      size="sm"
                      color="danger"
                      round
                      justIcon
                      disabled={loading}
                      onClick={cancelUpdate}
                    >
                      <Cancel />
                    </Button>
                  </>
                )}
              </GridContainer>
            }
          />
          <ReactTable
            excelName="Promociones"
            formatDate="DD-MM-YYYY"
            heightRow={50}
            defaultWidth={2400}
            columns={promotionTableColumns}
            data={promotions.map((item, index) =>
              mapPromotionData(
                item,
                setPromotions,
                index,
                listPromotions,
                selectedPromotions,
                setSelectedPromotions,
                edit,
              ),
            )}
          />
        </CardBody>
      </Card>
    </Fragment>
  );
});
